import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  levels: [],
};

const userLevelSlice = createSlice({
  name: "userLevel",
  initialState,
  reducers: {
    setUserLevel(state, action) {
      state.levels = action.payload || [];
    },
  },
});

export const { setUserLevel } = userLevelSlice.actions;

export default userLevelSlice.reducer;
